import type {BaseComponentPart} from '@Components/ai-chat-window/lib/stream-component-registry.types';
import type {StreamComponentType} from '@Components/ai-chat-window/lib/stream-component-registry.types';
import type {EntityCardStatus} from '@Components/ai-chat-window/components/entity-card/entity-card.types';

export interface EntityDraftSection {
  label: string;
  text: string;
}

export interface EntityDraftCardProps {
  title?: string;
  meta: string[];
  status?: EntityCardStatus;
  badge?: string;
  description?: string;
  mediaUrl?: string;
  mediaCount?: number;
  sections?: EntityDraftSection[];
  /** Short lines at the foot of the card, such as a platform's terms; they may carry links and are shown sanitized. */
  notes?: string[];
}

export type EntityDraftCardComponentPart = BaseComponentPart<StreamComponentType.ENTITY_DRAFT, EntityDraftCardProps>;

export const DESCRIPTION_TRUNCATE_LENGTH = 180;
